export default function _forceReduced(x) {
  return {
    '@@transducer/value': x,
    '@@transducer/reduced': true
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda/es/internal/_forceReduced.js
// module id = 968
// module chunks = 0